import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Langs, UserCenter } from './components';
import { HeaderDropdown } from '@/components';
import { MenuProps } from 'antd';
import styles from './Header.module.less';
import { DownOutlined } from '@ant-design/icons';

export const Header = () => {
  const { t } = useTranslation();

  const items: MenuProps['items'] = [
    {
      label: (
        <a
          href="https://www.dsers.com/developers/api-overview/"
          rel="noreferrer"
          target="_blank"
          style={{ textTransform: 'uppercase' }}
        >
          Overview
        </a>
      ),
      key: '1',
    },
    {
      label: (
        <a
          href="/auth_service"
          target="_blank"
          rel="noreferrer"
          style={{ textTransform: 'uppercase' }}
        >
          Auth Service
        </a>
      ),
      key: '2',
    },
    {
      label: (
        <a href="/api/channel_app_api#/" target="_blank" style={{ textTransform: 'uppercase' }}>
          Channel APP
        </a>
      ),
      key: '3',
    },
    {
      label: (
        <a
          href="/api/channel_middle_platform_api#/"
          target="_blank"
          style={{ textTransform: 'uppercase' }}
        >
          Middle Platform For Channel APP
        </a>
      ),
      key: '4',
    },
    {
      label: (
        <a href="/api/supplier_app_api#/" target="_blank" style={{ textTransform: 'uppercase' }}>
          Supplier APP
        </a>
      ),
      key: '5',
    },
    {
      label: (
        <a
          href="/api/supplier_middle_platform_api#/"
          target="_blank"
          style={{ textTransform: 'uppercase' }}
        >
          Middle Platform For Supplier APP
        </a>
      ),
      key: '6',
    },
    {
      label: (
        <a href="/status_and_error_codes" target="_blank" style={{ textTransform: 'uppercase' }}>
          Status And Error Codes
        </a>
      ),
      key: '7',
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <a className={styles.logoIcon}></a>
      </div>
      <div className={styles.topbarMenuCenter}>
        {window.location.pathname.includes('examine') ? null : (
          <Link to="/">{t('develop_prefix_my_app')}</Link>
        )}
        <span className={styles.zw}> </span>
        <a href="https://www.dsers.com/developers/supplier-app/" target="_blank" rel="noreferrer">
          SUPPLIER
        </a>
        <span className={styles.zw}> </span>
        <a href="https://www.dsers.com/developers/channel-app/" target="_blank" rel="noreferrer">
          SALES CHANNEL
        </a>
        <span className={styles.zw}> </span>

        <div className={styles.lastDrown}>
          <HeaderDropdown menu={{ items }}>
            <a href="#" className={styles.astyle}>
              API INTRODUCTION
            </a>
            <span className={styles.dropbtnImg}>
              <DownOutlined />
            </span>
          </HeaderDropdown>
        </div>
      </div>
      <div className={styles.topbarMenu}>
        <Langs />

        <span className={styles.zw}>|</span>
      </div>
      <div className={styles.topbarMenuUser}>
        <UserCenter />
      </div>
    </div>
  );
};
